export default "__VITE_ASSET__CgtKmyiX__"